import { Box } from '@mui/material'
import AdxFullWindowTitleBar from 'components/reusable/fullWindowTitleBar/AdxFullWindowTitleBar'
import CartItems from 'module/recruitment/pages/recruitment-cart/components/CartItems'
import { useNavigate } from 'react-router-dom'

const RecruitmentCart = () => {
  const navigate = useNavigate()

  // close button action
  const handleClose = () => {
    navigate('/app/recruitment')
  }

  return (
    <Box>
      <Box sx={{ position: 'fixed', width: '100%', zIndex: '1' }}>
        <AdxFullWindowTitleBar onClose={handleClose}>Candidate Cart</AdxFullWindowTitleBar>
      </Box>
      <Box bgcolor="gray-background.main" minHeight="calc(100vh - 19px)">
        <CartItems />
      </Box>
    </Box>
  )
}
export default RecruitmentCart
